import * as tslib_1 from "tslib";
import { NatModel } from "@natiwi/core/decorators/matadata.decorator";
import { OrmArgumentItem } from "@natiwi/core/models/argument-item";
let OrmPaymentOptionKindArgumentItem = class OrmPaymentOptionKindArgumentItem extends OrmArgumentItem {
    constructor() {
        super();
    }
};
OrmPaymentOptionKindArgumentItem = tslib_1.__decorate([
    NatModel({
        displayName: 'Аргумент',
        pluralDisplayName: 'Аргументы'
    })
], OrmPaymentOptionKindArgumentItem);
export { OrmPaymentOptionKindArgumentItem };
